// native
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-load',
    templateUrl: './load.component.html',
    standalone: false
})
export class LoadComponent {
  @Input() isLight: boolean = false;
}